import React from "react"
import { PiBlueprint } from "react-icons/pi"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { IconButton, } from "components"
import classes from "./OrderDetailsLabelPrintButton.module.scss"

const OrderDetailsLabelPrintButton = props => {
  const { order } = props

  const [t, i18n] = useTranslation()

  const handlePrintOrder = async () => {
    sessionStorage.setItem(
      "data",
      JSON.stringify({
        type: "courier",
        value: [order]
      })
    )

    window.open("/print", "_blank")
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      className={classes["container"]}
      onClick={handlePrintOrder}
    >
      <IconButton
        icon={PiBlueprint}
        size={18}
        loadingColor="black"
      />
      <span
        className={clsx(
          classes["text"],
          isLtr && classes["text-ltr"]
        )}
      >
        {t("پرینت_لیبل")}
      </span>
    </div>
  )
}

export default OrderDetailsLabelPrintButton